import { ApolloError } from 'apollo-client';
import { GraphQLError } from 'graphql';

import { type AGGError } from '@atlassian/relay-errors';

export class ApolloErrorInterop extends ApolloError {
	constructor(options: {
		graphQLErrors?: ReadonlyArray<GraphQLError | AGGError>;
		networkError?: Error | null;
		errorMessage?: string;
		extraInfo?: any;
	}) {
		const graphQLErrors = options.graphQLErrors?.map((error) => {
			const message = error.message;
			const nodes = 'nodes' in error ? error.nodes : undefined;
			const source = 'source' in error ? error.source : undefined;
			const positions = 'positions' in error ? error.positions : undefined;
			const path = error.path;
			const originalError = 'originalError' in error ? error.originalError : undefined;
			const extensions = error.extensions;

			return new GraphQLError(message, nodes, source, positions, path, originalError, extensions);
		});

		super({
			...options,
			graphQLErrors,
		});
	}
}
